import { thMeterSensorRegistry } from "./thMeterSensorRegistry";

export const generateThSensorsDemo = (meterId) => {
    const meterEntry = thMeterSensorRegistry.find(
        (m) => m.meter_id === Number(meterId)
    );

    if (!meterEntry || !meterEntry.sensors?.length) {
        return [
            {
                id: 999,
                sensor_name: "Generic Temperature Sensor",
            },
        ];
    }

    return meterEntry.sensors.map((sensor) => ({
        id: sensor.sensor_id,
        sensor_name: sensor.sensor_name,
    }));
};
